export const costOfInformationChaosData = [
  "Complex data architectures (especially if you've got legacy systems nobody wants to touch)",
  "Industry-specific terminology and business context that generic AI doesn't understand",
  'Actual security requirements and compliance mandates that your company has to fulfill',
  "Knowledge scattered across formats—structured databases, random wikis, PDFs nobody's opened since 2017",
  "The need to prove where information came from (audit trails aren't just optional)",
];
